module.exports = __webpack_public_path__ + "img/destination-ter.9c8b0fd3.svg";